<template>
  <div class="formGroup test" :data-layout="layout">
    <div class="formGroup__body">
      <formLabel :label="label" :validation="validation"></formLabel>

      <div class="customSwitch">
        <div class="customSwitch__switcher" v-for="(option,index) in options" :key="option.value">
          <input
          :name="name"
          :id="name + index"
          type="radio"
          class="radio__input"
          :value="option.value"
          :checked="checked === option.value"
          v-validate="validation"
          :data-error="errors.has(name)"
          @change="update($event)" >
          <label
          :for="name + index"
          >{{ option.text }}</label>
        </div>
      </div>
    </div>
    <div class="formGroup__footer">
      <slot></slot>
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-switch',
  mixins: [mixin],
  props: {
    options: { type: Array, required: true }
  },
  computed: {
    checked() {
      return !this.value ? this.options[0].value : this.value
    }
  },
  update($event) {
    const value = $event.target.value
    this.$emit('input', value)
    this.$emit('change', value)
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormSwitch.vue